export const EVENT_WIDGETS = `
    query eventWidgets($event_id: Uint) {
        eventWidgets(event_id: $event_id) {
            id
            type
            props
            created_at
            updated_at
            groups {
                id
                name
            }
        }
    }  
`;

export const WIDGET = `
    query widget($id: Uint) {
        widget(id: $id) {
            id
            type
            props
            created_at
            updated_at
            groups {
                id
                name
            }
        }
    } 
`;
